<div class="dialog-header">
	<h1 mat-dialog-title id="dialog-title" i18n="Dialog Title@@assetPickerDialogTitle">Select Asset</h1>
	<mat-icon [mat-dialog-close]="null" class="cursor-pointer" aria-label="Close dialog">close</mat-icon>
</div>

<div mat-dialog-content class="mt-3 asset-picker-dialog-content" role="region" aria-labelledby="dialog-title">
	<div class="content-wrapper" [class.with-sidebar]="shouldShowSidebar">
		<!-- Datasource Sidebar - Only shown when multiple enabled datasources exist -->
		<nav *ngIf="shouldShowSidebar"
			 class="datasource-sidebar"
			 [class.collapsed]="isSidebarCollapsed"
			 aria-label="Data sources"
			 role="navigation">
			<div class="sidebar-content">
				<div class="datasource-list" role="list">
					<button
						*ngFor="let datasource of enabledDatasources"
						class="datasource-item"
						[class.active]="activeDatasource?.id === datasource.id"
						(click)="selectDatasource(datasource)"
						[attr.aria-current]="activeDatasource?.id === datasource.id ? 'page' : null"
						[matTooltip]="isSidebarCollapsed ? datasource.name : ''"
						matTooltipPosition="right"
						role="listitem"
						type="button"
					>
						<span class="datasource-name" *ngIf="!isSidebarCollapsed">{{ getLocalizedName(datasource) }}</span>
						<span class="datasource-icon" *ngIf="isSidebarCollapsed" [attr.aria-label]="datasource.name">{{ datasource.name.charAt(0).toUpperCase() }}</span>
					</button>
				</div>
			</div>
			<!-- <button class="sidebar-toggle" (click)="toggleSidebar()" type="button" [attr.aria-label]="isSidebarCollapsed ? 'Expand sidebar' : 'Collapse sidebar'">
				<mat-icon *ngIf="!isSidebarCollapsed">chevron_left</mat-icon>
				<mat-icon *ngIf="isSidebarCollapsed">chevron_right</mat-icon>
			</button> -->
		</nav>

		<!-- Main Content Area -->
		<div class="main-content" [class.loading]="isLoadingAssets">
			<div class="mobile-datasource-selector" *ngIf="shouldShowSidebar">
				<app-select-input
					label="Select Datasource:"
					i18n-label="Select Datasource Label@@adCustomizationPropertiesSelectDatasourceLabel"
					[options]="enabledDatasources"
					[currentValue]="activeDatasource"
					(valueChange)="selectDatasource($event)">
				</app-select-input>
			</div>

			<!-- Asset Picker State -->
			<ng-container *ngIf="state === 'asset-picker'">
				<!-- Skeleton loading shown while loading -->
				<app-asset-skeleton *ngIf="isLoadingAssets" [count]="8"></app-asset-skeleton>

				<!-- Asset picker shown when not loading -->
				<app-asset-picker
					*ngIf="config && !isLoadingAssets"
					[config]="config"
					[selectedItems]="selectedItems"
					[sidebarCollapsed]="isSidebarCollapsed"
					[hasSidebar]="shouldShowSidebar"
					(selectItem)="selectItem($event)"
				></app-asset-picker>
			</ng-container>

			<!-- Upload State -->
			<ng-container *ngIf="state === 'upload'">
				<div class="upload-header">
					<button mat-icon-button (click)="returnToPicker()" aria-label="Back to asset picker" type="button">
						<mat-icon>arrow_back</mat-icon>
					</button>
					<h3 i18n="Upload Files Header@@assetPickerUploadFilesHeader">Upload Files</h3>
				</div>
				<div class="upload-content">
					<app-file-uploader [assetCategory]="config.mediaType" [hideSaveToField]="!(settings$ | async)?.enableSaveToProjectFiles" (isDone)="setState('asset-picker')"></app-file-uploader>
				</div>
			</ng-container>
		</div>
	</div>
</div>

<div mat-dialog-actions class="dialog-actions mt-4 pb-4" *ngIf="state === 'asset-picker'">
	<div class="left">
		<button *ngIf="config?.ui?.showUpload" class="upload-file" color="secondary" mat-flat-button (click)="setState('upload')" i18n="Upload Files Button@@assetPickerUploadFilesButton">Upload Files</button>

		<ng-container *ngIf="config.datasource.config.attribution">
			<span class="attribution" [innerHTML]="config.datasource.config.attribution"></span>
		</ng-container>

	</div>
	<div class="right">
		<button class="cancel" mat-flat-button (click)="skip()" i18n="Dialog Action Button@@dialogActionButtonCancelLabel">Cancel</button>
		<button
			mat-flat-button
			color="primary"
			class="button-extra-small"
			[disabled]="!selectedItems?.length || !selectionChanged"
			(click)="save()"
		>
			<span i18n="Dialog Action Button@@dialogActionButtonSelectLabel">Select</span>
		</button>
	</div>
</div>
